/*
 * Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { InjectionToken } from "@angular/core";

export let ENVIRONMENT_PROD = new InjectionToken<Boolean>("ENVIRONMENT_PROD");
